<template>
    <a class="btn btn-default mt-2 pull-right" :class="{'fixed-filters-button-active': fixedEditable}" style="text-decoration:none !important;"
       href="#" @click.prevent="toggleState"
       role="button"
       aria-controls="fixedFilters">
        <i v-if="fixedEditable" class="fa fa-lock" aria-hidden="true"></i>
        <i v-else class="fa fa-unlock-alt" aria-hidden="true"></i>
    </a>
</template>

<script>
import {EventBus} from "../../../mixins/event-bus";
import Cookies from "../../../mixins/cookies";

export default {
    name: "quatra-fixed-filters",
    mixins: [Cookies],
    props: {
        isFixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fixedEditable: false
        };
    },
    methods: {
        toggleState() {
            this.rememberFilters(!this.fixedEditable)
            this.setFix(!this.fixedEditable);

        },
        rememberFilters(disabled) {
            if (disabled) {
                this.setCookie('fixedFiltersDisabled', new URLSearchParams(Array.from(new FormData(document.getElementById('quatra-index-list-form')))).toString(), 365);
            } else {
                this.setCookie('fixedFiltersDisabled', null, 365);
            }
        },
        setFix(disabled) {
            $('#owner').prop('disabled', disabled);
            $('#subject').prop('disabled', disabled);
            EventBus.$emit('fixedFiltersDisabled', {
                disabled: disabled,
            });
            let clearFilterButton = $('#clearFilterButton');
            if (disabled) {
                clearFilterButton.hide();
            } else {
                clearFilterButton.show();
            }
            this.fixedEditable = disabled;

        }
    },
    mounted() {
        this.fixedEditable = this.isFixed;
        this.setFix(this.isFixed)
    }
}
</script>

<style scoped>
.fixed-filters-button-active {
    background-color: #000;
    color: #fff;
}
</style>
